const CACHE_KEY = {
	TASK: {
		CACHE: true,
	},
	AGENDA: {
		CACHE: true,
	},
	DEMAND: {
		CACHE: true,
	},
	CLIENT: {
		CACHE: true,
	},
	PROPERTY: {
		CACHE: true,
	},
	PROJECT: {
		CACHE: true,
	},
	CACHE_ORIGIN: '1',
	CACHE_CONDITION: '2',
	CACHE_FILTER: '3',
	CACHE_FILTER_PARAMETER: '4',
};

export const EVENT_BEFORE_CLOSE = "event-before-close";
export const EVENT_REFRESH_EDIT_MODE = "event-refresh-edit-mode";
export default CACHE_KEY;